module.exports = __webpack_public_path__ + "static/media/slider-middle.0686a152.JPG";